import { Channel } from "@/config/channel"
import { triggerSurvey, TriggerType } from "./survey-utils"

export const SandsivSurveyIdPS = {
  ThankYouPage: 15,
  Home: 18,
  Bonus: 22,
  PdvSignup: 26,
  TaxCode: 24,
  ResidenceAddress: 27,
  Contacts: 28,
  AccessData: 29,
  SelectDocument: 30,
  DocumentData: 31,
  SelfLimitations: 32,
  TermsAndConditions: 33,
  RecapOcr: 54,
} as const

type SurveyId = (typeof SandsivSurveyIdPS)[keyof typeof SandsivSurveyIdPS]

const apiUrl = "https://pokerstars-es-digi.sandsiv.com"

export function triggerSurveyPS(
  surveyId: SurveyId,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
  accountId?: string | null,
) {
  return triggerSurvey(
    apiUrl,
    surveyId,
    channel,
    triggerType,
    ipAddress,
    accountId,
  )
}

export function triggerSurveyBasedOnPathnamePS(
  pathname: string,
  channel: Channel,
  triggerType: TriggerType,
  ipAddress: string | null,
) {
  const surveyId = getSurveyId(pathname)
  if (surveyId == null) return false
  return triggerSurvey(apiUrl, surveyId, channel, triggerType, ipAddress)
}

function getSurveyId(pathname: string): SurveyId | null {
  const surveyIdByPathname: Record<string, SurveyId> = {
    "/": SandsivSurveyIdPS.Home,
    "/personal-data-address": SandsivSurveyIdPS.ResidenceAddress,
    "/personal-data-document": SandsivSurveyIdPS.DocumentData,
    "/recap-ocr": SandsivSurveyIdPS.RecapOcr,
    "/error/tax-code": SandsivSurveyIdPS.TaxCode,
    "/contacts": SandsivSurveyIdPS.Contacts,
    "/credentials": SandsivSurveyIdPS.AccessData,
    "/recharge-limits": SandsivSurveyIdPS.SelfLimitations,
    "/signup-bonus": SandsivSurveyIdPS.Bonus,
    "/terms-and-conditions": SandsivSurveyIdPS.TermsAndConditions,
  }

  return surveyIdByPathname[pathname] ?? null
}
